import { BinaryReader } from './utils';
export { createSerializeWire } from '@neo-one/client-common';
export function createDeserializeWire(deserializeWireBase) {
    return (options) => deserializeWireBase({
        context: options.context,
        reader: new BinaryReader(options.buffer),
    });
}

//# sourceMappingURL=Serializable.js.map
